import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWorklistFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 6H9C8.45 6 8 5.55 8 5V3C8 2.45 8.45 2 9 2H15C15.55 2 16 2.45 16 3V5C16 5.55 15.55 6 15 6ZM6.8 4H5C4.45 4 4 4.45 4 5V21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21V5C20 4.45 19.55 4 19 4H17.2V5C17.2 6.21274 16.2127 7.2 15 7.2H9C7.78726 7.2 6.8 6.21274 6.8 5V4ZM8.00002 9.40002C7.66865 9.40002 7.40002 9.66865 7.40002 10C7.40002 10.3314 7.66865 10.6 8.00002 10.6H16C16.3314 10.6 16.6 10.3314 16.6 10C16.6 9.66865 16.3314 9.40002 16 9.40002H8.00002ZM8.00002 13.4C7.66865 13.4 7.40002 13.6687 7.40002 14C7.40002 14.3314 7.66865 14.6 8.00002 14.6H16C16.3314 14.6 16.6 14.3314 16.6 14C16.6 13.6687 16.3314 13.4 16 13.4H8.00002ZM7.40002 18C7.40002 17.6687 7.66865 17.4 8.00002 17.4H16C16.3314 17.4 16.6 17.6687 16.6 18C16.6 18.3314 16.3314 18.6 16 18.6H8.00002C7.66865 18.6 7.40002 18.3314 7.40002 18Z",
		fill: "currentColor"
	})
});
export default SvgWorklistFilled;
